import Model from 'src/models/model'
import { TYPES as SALES_CHANNEL_TYPES } from 'src/models/model/concerns/SalesChannelRestrictable'
import { ORDER_ITEM_TYPES } from 'src/models/order-item/OrderItem'
import { isOutOfStock } from 'src/services/inventory/sales-restrictions'
import { toValue } from 'vue'

// Options is a hash containing fields that can be used to validate item availability.
const DEFAULT_OPTIONS = Object.freeze({
  salesChannel: null,
  order: null
})

export function useIsItemPackageAvailable () {
  const currentSite = Model.configuration?.currentSite

  function isItemPackageAvailable (itemPackage, { salesChannel, order } = DEFAULT_OPTIONS) {
    const itemPackageValue = toValue(itemPackage)

    if (_.isNil(itemPackageValue)) return false

    const salesChannelValue = toValue(salesChannel)
    const orderValue = toValue(order)

    // The Item Package must be active (not archived) to be presented
    if (itemPackageValue.archivable && !itemPackageValue.isActive) return false

    // The Item Package must be available on the current Sales Channel
    if (!itemPackageValue.isSalesChannelEnabled(salesChannelValue)) return false

    // The Item Package must not contain Tickets (Ticket Item Packages are available during Ticket Selection, not Item Selection)
    if (itemPackageValue.packageType === ORDER_ITEM_TYPES.TICKET) return false

    // If the Sales Channel is private, the Item Package is available, regardless of
    // Inventory or Sales Toggles (the Item Package may be shown without being selectable)
    if (_.includes(SALES_CHANNEL_TYPES.PRIVATE, salesChannelValue)) return true

    // Publicly available Item Packages are either "ready to serve" or can be delivered to the customer after an online purchase
    if (!currentSite.hasOnlineDelivery && itemPackageValue.requiresPreparation) return false

    const areAllItemVariationsAvailable = _.every(itemPackageValue.itemPackageItems.data, itemPackageItem => {
      // TODO OOS INDY-6757 This does not consider modifier requirements or stock
      if (itemPackageItem.itemVariation.salesDisabled) return false
      if (itemPackageItem.itemVariation.item.salesDisabled) return false

      return true
    })
    if (!areAllItemVariationsAvailable) return false

    if (!_.isNil(orderValue) && currentSite?.activeInventoryStrategy?.excludeOutOfStockItemsForKioskAndConsumer) {
      // TODO OOS INDY-6757 This checks if the Item is out of stock, not the specific Item Variation
      // The Item Variation expects an OrderItem, not an Order for stock checks
      const isAnyItemOutOfStock = _.some(itemPackageValue.itemPackageItems.data, itemPackageItem =>
        isOutOfStock(itemPackageItem.itemVariation.item, { order: orderValue })
      )

      if (isAnyItemOutOfStock) return false
    }

    return true
  }

  return {
    isItemPackageAvailable
  }
}
